module.exports = __webpack_public_path__ + "static/media/surface_laptop.1368f96d.png";